export default __webpack_public_path__ + "static/loader-c5a5ea20284996a37b3cd848a23f73a9.gif";